import React, { useEffect, useMemo, useState } from 'react'
import Button from './Button';
import Spinner from './Spinner';
import { toast } from 'react-toastify';
import { Inertia } from '@inertiajs/inertia';
import axios from 'axios';

const GenerateExportButton = ({ children, route: routeToExport, date = null, endDate = null, branchOffice = null }) => {

    const [loadingScheduling, setLoadingScheduling] = useState(false);
    const [jobId, setJobId] = useState(null);
    const [isChecking, setIsChecking] = useState(false);

    useEffect(() => {
        if (!jobId) return;
        setIsChecking(true);

        const interval = setInterval(async () => {
            try {
                const response = await axios.get(route('export.request.check', { uuid: jobId }));
                if (response.data.status === 'success') {
                    const messages = {
                        'exportation.completed': 'El reporte se generó correctamente.',
                    }

                    const message = messages[response.data.code];
                    toast.success(message);
                    setJobId(null);

                    if (response.data.code === 'exportation.completed') {
                        clearInterval(interval)
                        Inertia.reload({ only: ['exportRequests'] })
                        setIsChecking(false);
                    }
                }
            } catch (error) {
                console.log({error});
                setIsChecking(false);
            }
        }, 5000);
    }, [jobId]);

    const handleGenerateExport = async () => {
        if (!linkIsAvailable) return;
        setLoadingScheduling(true);

        try {
            const response = await axios.post(route(routeToExport, { date, endDate, branchOffice }));
            if (response.data.status === 'success') {
                const messages = {
                    'exportation.scheduled': 'El reporte se está generando.',
                }

                const message = messages[response.data.code];
                toast.success(message);

                setJobId(response.data.job_id);
            }
        } catch (error) {
            console.log({error});
            toast.error('Ocurrió un error al generar el reporte.');
        }

        setLoadingScheduling(false);
    }

    const linkIsAvailable = useMemo(() => {
        if (loadingScheduling) return false;
        if (isChecking) return false;
        return true;
    }, [loadingScheduling, isChecking])

    return (
        <div>
            <Button className="flex justify-center items-center" onClick={handleGenerateExport} processing={!linkIsAvailable} type="button">
                {loadingScheduling ? <Spinner width="1rem" height="1rem" weight={2} color="transparent" backgroundColor="#ffffff" /> : children}
            </Button>
        </div>
    )
}

export default GenerateExportButton